import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { CabinetMaps } from '@/features/shelf/CabinetMaps'

interface ShelfSearch {
  q?: string
}

export const Route = createFileRoute('/shelf/')({
  validateSearch: (search: Record<string, unknown>): ShelfSearch => ({
    // The router reads ?q=470 as a number; a search term is text either way.
    q:
      (typeof search.q === 'string' || typeof search.q === 'number') && String(search.q)
        ? String(search.q)
        : undefined,
  }),
  component: ShelfHome,
})

function ShelfHome() {
  const { q } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onQuery = useCallback(
    (next: string) => void navigate({ search: { q: next || undefined }, replace: true }),
    [navigate],
  )
  return <CabinetMaps q={q ?? ''} onQuery={onQuery} />
}
